const UnfriendModal = ({ isOpen, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <div className="unfriendModalOverlay">
            <div className="unfriendModal">
                <h3>
                    Unfriend User
                </h3>
                
                <p>
                    Are you sure you want to remove this friend?
                </p>
                
                <div className="modalActions">
                    <button className="cancelBtn" onClick={onCancel}>
                        Cancel
                    </button>
                    
                    <button className="confirmBtn" onClick={onConfirm}>
                        Unfriend
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UnfriendModal;